<script>
  import TextField from "../utils/TextField.svelte";
  import Textarea from "../utils/Textarea.svelte";
  import { support } from "../api";
  import Description from "./Description.svelte";
  import { PHP, alert } from "../store";
  import constraints from "./validators";
  import { validate } from "validate.js";
  import to from "await-to-js";

  let form = {
    subject: "",
    message: ""
  };

  // to check for the validation, it is necessary to have
  // email if user is not activated
  if (!$PHP.isActivated) form = { ...form, email: "" };

  let error = {
    subject: "",
    message: "",
    email: ""
  };

  let inprogress = false;

  const send = async function(event) {
    error = validate(form, constraints, {
      format: "svelte",
      fullMessages: false
    });

    if (error) return;

    inprogress = true;

    const [responseError, response] = await to(support(form));

    inprogress = false;

    if (response) {
      alert.setWithTimeout({value: "We will respond to your message as soon as possible via email", className: "is-success"})
      form.subject = "";
      form.message = "";
      if (form.email) form.email = "";
    }
  };
</script>

<div class="container is-fluid">
  <div class="notification">
    <Description />
    <br />
    <TextField
      title="Subject"
      bind:value={form.subject}
      error={(error || {}).subject}
      placeholder="Subject" />
    {#if !$PHP.isActivated}
      <TextField
        title="Email"
        bind:value={form.email}
        error={(error || {}).email}
        placeholder="Email" />
    {/if}
    <Textarea
      title="Message"
      bind:value={form.message}
      placeholder="Message"
      error={(error || {}).message} />
    <div class="buttons is-centered">
      <button
        class="button is-success is-outlined"
        on:click={send}
        class:is-loading={inprogress}
        disabled={inprogress}>
        Send
      </button>
    </div>
  </div>
</div>
